<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="page-title">Transfers</h4>  
    </div>
     <div class="col-md-12 min-vh-100">

        <section class="content-inner">
          
          <div class="col-md-12 px-0 add-torrent" >
            <a href="/premium" class="text-decoration-none" v-if="!is_premium">
              <div class="mb-4 pl-4 alert alert-danger">
                  Your account has no premium membership. Downloads and streams will not work. Please click <span style="color: #606060;">here</span> to get premium.
              </div>
            </a>
            <flash message="" class="mb-4 pl-4"></flash>
            <div class="d-block d-md-none">
              <button class="btn btn-primary btn-lg btn-block upload-torrent" v-show="uploaded_torrent == 0"><i class="fas fa-plus-circle"></i> Add New NZB</button>
              <transition name="slide">
                <div v-show="uploaded_torrent > 0" id="addingTorrent">
                  <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="nav-add-mobile" role="tabpanel" aria-labelledby="nav-add-tab">
                      <!-- <h2 class="text-center"><b>Add New NZB</b></h2> -->
                     <!--  <form @submit.prevent="create($event)"> -->
                        <!-- <div class="form-group">
                          <div class="torrent_links  d-none">
                             <textarea name="links" v-model="form.links" @focusin="onFocusIn" @focusout="onFocusOut"  cols="5" id="torrent_links" class="form-control js__torrent-link-textarea"></textarea>
                          </div>
                          
                          <div class="torrent_link">
                             <input type="text" name="links" v-model="form.links" @paste="onPaste" @keydown.enter.prevent="onEnter" @focusin="onFocusIn" @focusout="onFocusOut" class="form-control js__torrent-link" id="torrent_link" placeholder="Paste your .nzb links here">
                          </div>
                        </div>
                        <div class="form-group"> 
                          <div class="strike">
                              <span> or </span>
                          </div>
                        </div> -->
                        <!-- <div class="form-group">
                          <div class="row no-gutters align-items-center">
                            <div class="col-6 text-center">
                              <p class="mb-0">Upload Your NZB here:</p>
                            </div>
                            <div class="col-6  text-center">
                              <vue-dropzone ref="myVueDropzone" id="dropzone" class="border-none" @vdropzone-file-added="selectFile" @vdropzone-sending="uploadingFile" @vdropzone-success="uploadSuccess" @vdropzone-error="uploadError"  :options="dropzoneOptions"  :useCustomSlot=true>
                                <button class="btn btn-primary btn-block upload-torrent mr-2">Upload NZB</button>
                              </vue-dropzone>
                            </div>
                          </div>
                        </div> -->
                        <div class="form-group" v-show="uploaded_files.length > 0 || form.links.length > 0">
                          <div class="row">
                            <div class="col-12" v-for="(link, index) in splitedLink"> 
                              <p class="text-truncate">{{ link }}</p>
                              <input type="text" name="password"  v-model="form.passwords[index]" class="form-control mb-3" @change="handleChange(index,$event)"  placeholder="Optional unpack passwords">
                            </div>
                            <div class="col-12" v-for="(file, index) in uploaded_files"> 
                              <p class="text-truncate">{{ file.name }}</p>
                             <input type="text" name="password" class="form-control  mb-3" @change="handleChange(index,$event)"  placeholder="Optional unpack passwords">
                            </div>             
                          </div>
                        </div>
                        <div class="form-group text-center">
                          <button class="btn btn-lg btn-primary btn-block mb-3"  @click="processNZB($event)" id="process_nzb">Add new transfer</button> 
                          <p class="text-muted text-center add_torrent_cancel"  @click="hideTransfer($event)">Cancel</p>
                        </div>
                      <!-- </form> -->
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="d-none d-md-block">
              <!-- <nav>
                <div class="nav nav-tabs border-0" id="nav-tab" role="tablist">
                  <a class="nav-link  border-0 active" id="nav-add-tab" data-toggle="tab" href="#nav-add" role="tab" aria-controls="nav-add" aria-selected="true"><svg class="icon icon-link"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-link"></use></svg> Add torrent link
                    <span class="tabs-navigation-arrow"></span>
                  </a>
                  <a class="nav-link  border-0" id="nav-upload-tab" data-toggle="tab" href="#nav-upload" role="tab" aria-controls="nav-upload" aria-selected="false"><svg class="icon icon-upload"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-upload"></use></svg> Upload torrent from PC 
                    <span class="tabs-navigation-arrow"></span>
                  </a>
                </div>
              </nav> -->
                 

              <div class="row">
                <!-- <div class="col-md-12">
                   <form @submit.prevent="create($event)">
                    <div class="row torrent_links  d-none">
                        <div class="col-12">
                          <div class="form-group pt-md-0 px-0">
                             <textarea name="links" v-model="form.links" @focusin="onFocusIn" @focusout="onFocusOut"  cols="5" id="torrent_links" class="form-control js__torrent-link-textarea"></textarea>

                          </div>
                        </div>
                    </div>
                    <div class="input-group input-group-lg torrent_link">
                      <input type="text" name="links" v-model="form.links" @paste="onPaste" @keydown.enter.prevent="onEnter" @focusin="onFocusIn" @focusout="onFocusOut" class="form-control js__torrent-link" id="torrent_link" placeholder="Paste your .nzb links here">

                    </div>
                  </form>
                </div>
                <div class="col-md-12">
                  <p class="text-center my-3 or">or</p>
                </div> -->
                <div class="col-md-12 text-center" id="dropzone_uploader">
                    <vue-dropzone ref="myVueDropzone" id="dropzone" @vdropzone-file-added="selectFile" @vdropzone-sending="uploadingFile" @vdropzone-success="uploadSuccess" @vdropzone-error-multiple="uploadError"   :options="dropzoneOptions"  :useCustomSlot=true>
                      <div class="dropzone-custom-content uploader_dropzone">
                        <img src="img/add_nzb.svg" class="img img-fluid  mx-auto d-block" style="height:90px;">
                        <p class="text-center mt-2"> Drag and drop .nzb files here <br>or<br> <a href="#" @click="resetDropzone" class="upload-torrent btn btn-primary mt-2" style="width: 200px;">Upload .nzb</a></p>
                      </div>
                      <div class="text-center uploader_complete d-none">
                           <p class="mt-4"><i class="fas fa-check-circle text-success mr-2"></i>{{uploaded_torrent}} file(s) successfully selected</p>
                          <span class="sprite-arrow"></span>
                      </div>
                    </vue-dropzone>
                </div>
                 <div class="col-md-12 mt-3"  v-show="uploaded_files.length > 0 || form.links.length > 0">
                  <table class="table table-bordered">
                    <tr v-for="(link, index) in splitedLink">
                      <td  class="align-middle w-50 text-truncate" style="max-width: 150px;">{{ link }}</td>
                      <td  class="align-middle"><input type="text" name="password"  v-model="form.passwords[index]" class="form-control" @change="handleChange(index,$event)"  placeholder="Optional unpack passwords (not needed if already in the filename)"></td>
                    </tr>
                    <tr v-for="(file, index) in uploaded_files">
                      <td class="align-middle  w-50  text-truncate" style="max-width: 150px;">{{ file.name }}</td>
                      <td  class="align-middle"><input type="text" name="password" class="form-control" @change="handleChange(index,$event)"  placeholder="Optional unpack passwords (not needed if already in the filename)"></td>
                    </tr>
                  </table>                 
                </div>
                <div class="col-md-12" v-if="uploaded_torrent > 0">
                  <button class="btn btn-lg mt-3  btn-primary btn-block"  @click="processNZB($event)" id="process_nzb">Add new transfer</button> 
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 px-0 block">


            <!-- <ul class="nav nav-pills nav-fill mt-5">
              <li class="nav-item">
                <a class="nav-link" href="# ">Finished</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#inprogress">In Progress</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#error">Error</a>
              </li>
            </ul> -->
            <ul class="nav nav-pills nav-fill mt-5" id="pills-tab" role="tablist">
              <li class="nav-item all">
                <a class="nav-link active " id="pills-all-tab" data-toggle="pill" href="#pills-all" role="tab" aria-controls="pills-all" aria-selected="true"><i class="fas fa-list pull-left"></i> All</a>
                <div class="active"></div>
              </li>
              <li class="nav-item ml-md-4 finished">
                
                <a class="nav-link" id="pills-finished-tab" data-toggle="pill" href="#pills-finished" role="tab" aria-controls="pills-finished" aria-selected="false"><i class="fas fa-play pull-left"></i> Finished</a>
              
              </li>
              <li class="nav-item mx-md-4 inprogress">
                <a class="nav-link" id="pills-progress-tab" data-toggle="pill" href="#pills-progress" role="tab" aria-controls="pills-progress" aria-selected="false"><i class="fas fa-sync-alt  pull-left"></i> Loading</a>
              </li>
              <li class="nav-item error">
                <a class="nav-link" id="pills-error-tab" data-toggle="pill" href="#pills-error" role="tab" aria-controls="pills-error" aria-selected="false"><i class="fas fa-times  pull-left"></i> Error</a>
              </li>
            </ul>

            <div v-if="typeof(transfers_finished.length) === 'undefined' && typeof(transfers_running.length) === 'undefined' && typeof(transfers_queued.length) === 'undefined' && typeof(transfers_error.length) === 'undefined'" class="text-center my-5">
                  <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
            </div>

            <div v-else  class="tab-content mt-5" id="pills-tabContent">
              <div class="tab-pane fade show active" id="pills-all" role="tabpanel" aria-labelledby="pills-all-tab">
                  <div class="row">
                    <div class="col-md-12 transfer_list">
                      <div class="card mb-3" v-bind:class="{'running' : transfer.status == 'running'}" v-for="(transfer, index) in transfers_all">
                        <div v-show="transfer.status == 'running'" class="bg" :style="[transfer.progress*100 > 0 ? { width: transfer.progress*100 + '%', background: 'rgba(147,224,51,.4)'} : { }]"></div>
                        <div class="card-body" v-if="transfer.status == 'finished'">
                            <div class="d-flex flex-row">
                              <div class="d-flex flex-grow-0 justify-content-center align-self-center transfer-icon">
                                <svg class="icon icon-play" v-if="transfer.file_id !== null"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-play"></use></svg>
                                <svg class="icon icon-folder" v-else="transfer.file_id !== null"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-folder"></use></svg>
                              </div>
                              <div class="name d-flex flex-grow-1 text-white justify-content-start align-self-center">
                                <div class="d-flex flex-column">
                                    <span class="transfer-name">
                                      <a v-if="transfer.file_id !== null" v-bind:href="'/files/file?id=' + transfer.file_id">{{ transfer.name }}</a>
                                      <a v-else v-bind:href="'/files?folder_id=' + transfer.folder_id">{{ transfer.name }}</a>
                                    </span>
                                    <div class="d-flex flex-row actions" v-if="transfer.file_id !== null">
                                      <div>
                                        <a v-bind:href="'/files/file?id=' + transfer.file_id">Play</a>
                                      </div>
                                      <div>
                                        <a href="javascript:void(0);">Download</a>
                                      </div>
                                    </div>

                                    <div class="d-flex flex-row actions" v-else>
                                      <div>
                                        <a v-bind:href="'/files?folder_id=' + transfer.folder_id">Open</a>
                                      </div>
                                      <div>
                                        <a href="javascript:void(0);" @click="zipTransfer($event,index,transfer.folder_id,null)">Download (Zip)</a>
                                      </div>
                                    </div>
                                </div>
                              </div>
                              <div class="action d-flex flex-grow-0 text-white justify-content-center align-self-center">
                                <button class="btn px-0 px-md-3" @click="deleteConfirm(transfer)" v-bind:id="'delete_'+transfer.id"><i class="fas fa-times-circle text-secondary"></i></button>
                              </div>
                            </div>
                        </div>

                        <div class="card-body" v-else-if="transfer.status == 'running'">
                            <div class="d-flex flex-row " >
                              
                              <div class="d-flex flex-grow-0 justify-content-center align-self-center transfer-icon">
                                <svg class="icon icon-refresh"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-refresh"></use></svg>
                              </div>
                              <div class="name d-flex flex-grow-1 text-white justify-content-start align-self-center">
                                <div class="d-flex flex-column">
                                    <span class="transfer-name">{{ transfer.name }}</span>
                                    <small class="text-secondary">{{ transfer.message }}</small>
                                </div>
                              </div>
                              <div class="action d-flex flex-grow-0 text-white justify-content-center align-self-center">
                                <button class="btn  px-0 px-md-3" @click="deleteConfirm(transfer)" v-bind:id="'delete_'+transfer.id"><i class="fas fa-times-circle text-secondary"></i></button>
                              </div>
                            </div>
                        </div>
                        <div class="card-body" v-else-if="transfer.status == 'queued'">
                            <div class="d-flex flex-row " >
                             
                              <div class="d-flex flex-grow-0 justify-content-center align-self-center transfer-icon">
                                <svg class="icon icon-refresh"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-refresh"></use></svg>
                              </div>
                              <div class="name d-flex flex-grow-1 text-white justify-content-start align-self-center">
                                <div class="d-flex flex-column">
                                    <span class="transfer-name">{{ transfer.name }}</span>
                                    <small class="text-secondary">{{ transfer.message }}</small>
                                </div>
                              </div>
                              <div class="action d-flex flex-grow-0 text-white justify-content-center align-self-center">
                                <button class="btn px-0 px-md-3" @click="deleteConfirm(transfer)" v-bind:id="'delete_'+transfer.id"><i class="fas fa-times-circle text-secondary"></i></button>
                              </div>
                            </div>
                        </div>
                        <div class="card-body" v-else-if="transfer.status == 'error'">
                            <div class="d-flex flex-row" >
                              
                              <div class="d-flex flex-grow-0 justify-content-center align-self-center transfer-icon">
                                <svg class="icon icon-times"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-times"></use></svg>
                              </div>
                              <div class="name d-flex flex-grow-1 text-white justify-content-start align-self-center">
                                <div class="d-flex flex-column">
                                    <span class="transfer-name">{{ transfer.name }}</span>
                                    <small class="text-secondary">{{ transfer.message }}</small>
                                </div>
                              </div>
                              <div class="action d-flex flex-grow-0 text-white justify-content-center align-self-center">
                                <button class="btn px-0 px-md-3" @click="deleteConfirm(transfer)" v-bind:id="'delete_'+transfer.id"><i class="fas fa-times-circle text-secondary"></i></button>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="tab-pane fade" id="pills-finished" role="tabpanel" aria-labelledby="pills-finished-tab">
                <div class="row" v-if="transfers_finished.length > 0">
                  <div class="col-md-12 transfer_list">
                    <div class="card mb-3" v-for="(transfer, index) in transfers_finished">
                        <div class="card-body">
                            <div class="d-flex flex-row">
                              <div class="d-flex flex-grow-0 justify-content-center align-self-center transfer-icon">
                                <svg class="icon icon-play" v-if="transfer.file_id !== null"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-play"></use></svg>
                                <svg class="icon icon-folder" v-else="transfer.file_id !== null"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-folder"></use></svg>
                              </div>
                              <div class="name d-flex flex-grow-1 text-white justify-content-start align-self-center">
                                <div class="d-flex flex-column">
                                    <span class="transfer-name">
                                      <a v-if="transfer.file_id !== null" v-bind:href="'/files/file?id=' + transfer.file_id">{{ transfer.name }}</a>
                                      <a v-else v-bind:href="'/files?folder_id=' + transfer.folder_id">{{ transfer.name }}</a>
                                    </span>
                                    <div class="d-flex flex-row actions" v-if="transfer.file_id !== null">
                                      <div>
                                        <a v-bind:href="'/files/file?id=' + transfer.file_id">Play</a>
                                      </div>
                                      <div>
                                        <a href="">Download</a>
                                      </div>
                                    </div>

                                    <div class="d-flex flex-row actions" v-else>
                                      <div>
                                        <a v-bind:href="'/files?folder_id=' + transfer.folder_id">Open</a>
                                      </div>
                                      <div>
                                        <a href="javascript:void(0);" @click="zipTransfer($event,index,transfer.folder_id,null)">Download (Zip)</a>
                                      </div>
                                    </div>
                                </div>
                              </div>
                              <div class="action d-flex flex-grow-0 text-white justify-content-center align-self-center">
                                <button class="btn px-0 px-md-3" @click="deleteConfirm(transfer)" v-bind:id="'delete_'+transfer.id"><i class="fas fa-times-circle text-secondary"></i></button>
                              </div>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="pills-progress" role="tabpanel" aria-labelledby="pills-progress-tab">
                <div class="row" v-if="transfers_running.length > 0">
                  <div class="col-md-12  transfer_list">
                      <div class="card mb-3" v-for="(transfer, index) in transfers_queued">
                        <div class="card-body">
                            <div class="d-flex flex-row " >
                             
                              <div class="d-flex flex-grow-0 justify-content-center align-self-center transfer-icon">
                                <svg class="icon icon-search"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-search"></use></svg>
                              </div>
                              <div class="name d-flex flex-grow-1 text-white justify-content-start align-self-center">
                                <div class="d-flex flex-column">
                                    <span class="transfer-name">{{ transfer.name }}</span>
                                    <small class="text-secondary">{{ transfer.message }}</small>
                                </div>
                              </div>
                              <div class="action d-flex flex-grow-0 text-white justify-content-center align-self-center">
                                <button class="btn px-0 px-md-3" @click="deleteConfirm(transfer)" v-bind:id="'delete_'+transfer.id"><i class="fas fa-times-circle text-secondary"></i></button>
                              </div>
                            </div>
                        </div>
                      </div>
                      <div class="card mb-3 running" v-for="(transfer, index) in transfers_running">
                        <div class="bg" :style="[transfer.progress*100 > 0 ? { width: transfer.progress*100 + '%', background: 'rgba(147,224,51,.4)'} : { }]"></div>
                        <div class="card-body">
                          <div class="d-flex flex-row">
                            
                            <div class="d-flex flex-grow-0 justify-content-center align-self-center transfer-icon">
                              <svg class="icon icon-refresh"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-refresh"></use></svg>
                            </div>
                            <div class="name d-flex flex-grow-1 text-white justify-content-start align-self-center">
                              <div class="d-flex flex-column">
                                  <span class="transfer-name">{{ transfer.name }}</span>
                                  <small class="text-secondary">{{ transfer.message }}</small>
                              </div>
                            </div>
                            <div class="action d-flex flex-grow-0 text-white justify-content-center align-self-center">
                              <button class="btn px-0 px-md-3" @click="deleteConfirm(transfer)" v-bind:id="'delete_'+transfer.id"><i class="fas fa-times-circle text-secondary"></i></button>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="pills-error" role="tabpanel" aria-labelledby="pills-error-tab">
                  <div class="row" v-if="transfers_error.length > 0">
                    <div class="col-md-12  transfer_list">
                        <div class="card mb-3" v-for="(transfer, index) in transfers_error">
                            <div class="card-body">
                                <div class="d-flex flex-row">
                                  <div class="d-flex flex-grow-0 justify-content-center align-self-center transfer-icon">
                                    <svg class="icon icon-times"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-times"></use></svg>
                                  </div>
                                  <div class="name d-flex flex-grow-1 text-white justify-content-start align-self-center">
                                    <div class="d-flex flex-column">
                                        <span class="transfer-name">
                                          {{ transfer.name }}
                                        </span>
                                        <small class="text-secondary">{{ transfer.message }}</small>
                                    </div>
                                  </div>
                                  <div class="action d-flex flex-grow-0 text-white justify-content-center align-self-center">
                                    <button class="btn px-0 px-md-3" @click="deleteConfirm(transfer)" v-bind:id="'delete_'+transfer.id"><i class="fas fa-times-circle text-secondary"></i></button>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <div class="modal fade" id="zipModal" tabindex="-1" role="dialog" aria-labelledby="zipModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h6 class="modal-title">Zip Download</h6>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="col-md-12 p-2 text-center" v-if="!zip_data.finish">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <div v-else class="text-center">
                      <div class="alert alert-danger" role="alert" v-if="zip_data.error != null">
                        {{zip_data.error}}
                      </div>
                      <div v-else class="row">
                        <div class="col-12 col-md-6 offset-md-3">
                          <button type="button" class="btn btn-primary btn-block my-1" @click="downloadURL(zip_data.link)" data-dismiss="modal">Start to download</button>
                        </div>
                        <div class="col-12 col-md-6 offset-md-3"> 
                          <button type="button" class="btn btn-primary btn-border btn-block  my-1" v-tooltip:top="'Copy download link'" @click="copyToClipboard" data-dismiss="modal"><i class="fas fa-copy"></i> Copy link</button>
                        </div>
                      </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <div class="d-flex flex-row">
                      <div class="justify-content-center align-self-center text-center flex-grow-1">
                       <div class="form-check p-0">
                          <label class="form-check-label" style="margin-bottom:0px!important;">
                            <input class="form-check-input" type="checkbox" v-model="form.always_start_download"  @change="alwaysStartDownload($event)">
                            <p class="form-check-sign mb-0">Always start to download</p>
                          </label>
                        </div>
                      </div>
                      
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
             <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h6 class="modal-title">Are you sure you want to delete the following?</h6>
                  </div>
                   <div class="modal-body">
                      <div class="row pmcard-row">
                          <div class="col-1">
                            <i class="fas fa-file-download" v-if="delete_item.type == 'file'"></i> 
                             <i class="fas fa-folder" v-else></i> 
                          </div>
                          <div class="col-10 px-md-0">
                            <p class="text-left mb-0" style="word-break: break-all;">
                             {{ delete_item.name }}
                            </p>
                         </div>
                      </div>
                   </div>
                   <div class="modal-footer">
                    <div class="d-flex flex-row">
                      <div class="justify-content-start align-self-center">
                       <div class="form-check p-0">
                          <label class="form-check-label" style="margin-bottom:0px!important;">
                            <input class="form-check-input" type="checkbox" v-model="form.ask">
                            <p class="form-check-sign mb-0">Don't ask me again</p>
                          </label>
                        </div>
                      </div>
                      <div class="ml-auto">
                        <button type="button" class="btn btn-link text-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="deleteTransfer">Delete</button>
                      </div>
                    </div>
                   </div>
                </div>
             </div>
          </div>
        </section>
      </div>
  </div>
</template>
 
<script>

    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        components: {
          vueDropzone: vue2Dropzone

        },
        props: ['message','folders','premium'],
        data() {
            return {
                tree : null,
                is_premium: this.premium,
                selectedNode: null,
                contextMenuItems: [{code: 'DELETE_NODE', label: 'Delete node'}, {
                    code: 'ADD_CHILD_NODE',
                    label: 'Add child'
                }, {code: 'RENAME_NODE', label: 'Rename'}],
                dropzoneOptions: {
                    url: '/api/transfers/create',
                    autoDiscover: false,
                    uploadMultiple: true,
                    parallelUploads: 10,
                    maxFiles: 10,
                    autoProcessQueue : false,
                    paramName: "file",
                    acceptedFiles: '.nzb',
                    previewsContainer: false,
                    // params: () => ({
                    //   folder_id: this.folder_id
                    // }),
                    clickable: '.upload-torrent',
                    "error": function(file, message, xhr) {
                       if (xhr == null) this.removeFile(file); // perhaps not remove on xhr errors
                    },
                    headers: {
                      "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                     }
                },
                mobile_transfer : false,
                transfers_finished: {},
                transfers_running: {},
                transfers_queued: {},
                transfers_error: {},
                transfers_all: {},
                processNZBBtn: true,
                form: { links: [], passwords:[] },
                uploaded_torrent: 0,
                uploaded_files: {},
                counter: 0,
                passwords : [],
                folder_name: 'Files',
                folder_id: null,
                selected_folder : {},
                zip_data: { link: null, finish: false, error: null },
                delete_item: {},
            }
        },
        mounted() {
          this.list();
          this.updateList();
          //localStorage.confirm_delete = true;
        },
        computed: {
          splitedLink(){
            if(this.form.links.length > 0) {
              var links = this.form.links.split('\n');
              var filtered_lines = links.filter(function (el) {
                return el != '' ;
              });
              return filtered_lines;
            }
          }
        },
        methods: {
           copyToClipboard(){
              if (window.clipboardData && window.clipboardData.setData) {
                // IE specific code path to prevent textarea being shown while dialog is visible.
                return clipboardData.setData("Text", this.zip_data.link);

              } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                var textarea = document.createElement('textarea');
                textarea.textContent = this.zip_data.link;
                document.body.appendChild(textarea);
                var selection = document.getSelection();
                var range = document.createRange();
                range.selectNode(textarea);
                selection.removeAllRanges();
                selection.addRange(range);
                try {
                  return document.execCommand("copy"); // Security exception may be thrown by some browsers.
                } catch (ex) {
                  console.warn("Copy to clipboard failed.", ex);
                  return false;
                } finally {
                  selection.removeAllRanges();
                  document.body.removeChild(textarea);
                }
              }
            },
            alwaysStartDownload(e){
              if(this.form.always_start_download == 'true' || this.form.always_start_download == true){
                  localStorage.always_start_download = true;
              } else {
                  localStorage.always_start_download = false;
              }
            },
            changeFolder (id,name) {
                this.selected_folder = {'id' : id, 'name' : name};
            },
            setFolder () {
                this.folder_name = this.selected_folder.name;
                this.folder_id = this.selected_folder.id;
                $('#selectFolderModal').modal('toggle');
            },
            selectFile(){
              this.processNZBBtn = false;
              $('.uploader_dropzone').addClass('d-none');
              $('.uploader_complete').removeClass('d-none');
              //console.log(this.$refs.myVueDropzone.dropzone.files,this.$refs.myVueDropzone.dropzone.files.length);
              this.uploaded_torrent = this.$refs.myVueDropzone.dropzone.files.length;
              this.uploaded_files = this.$refs.myVueDropzone.dropzone.files;
            },
            uploadingFile(file, xhr, formData){

              if(typeof(this.passwords[this.counter]) !== 'undefined'){
                formData.append('password['+this.counter+']', this.passwords[this.counter]);
                this.counter = this.counter + 1;
              }
            },
            updateList(){
              clearInterval(this.interval);
              this.interval = setInterval(this.list, 5000);
            },
            processNZB(e) {

              // if( this.form.links.length > 0 && this.uploaded_torrent == 0) {

              //   var links = this.form.links.split('\n');
              //   var filtered_lines = links.filter(function (el) {
              //     return el != '' ;
              //   });

              //   $('#process_nzb').html('<i class="fas fa-spinner fa-pulse"></i>').removeClass('btn-primary').addClass('btn-secondary').prop('disabled', true);
    
              //   axios.post('/api/transfers/create',{link : filtered_lines, passwords: this.form.passwords , folder_id : this.folder_id}).then(response=>{

              //     $('#process_nzb').html('Add New NZB').removeClass('btn-secondary').addClass('btn-primary').prop('disabled', false);

              //     this.form.links = '';
                  
              //     if(response.data.status == 'success'){
              //       this.updateList();
              //       flash(response.data.message, response.data.alert);
              //     } 
                 
              //   }).catch(error=>{
              //       flash(JSON.parse(error.request.response).message, 'error');
              //       $('#process_nzb').html('Add New NZB').removeClass('btn-secondary').addClass('btn-primary').prop('disabled', false);
              //   });

              // } else if(this.form.links.length == 0 && this.uploaded_torrent > 0) {

              if(this.uploaded_torrent > 0){

                // alert(e.target.id);

                this.$refs.myVueDropzone.processQueue();
                $('button#process_nzb').html('<i class="fas fa-spinner fa-pulse"></i>').removeClass('btn-primary').addClass('btn-secondary').prop('disabled', true);

              } else {

                e.preventDefault();
                
              }
              // } else if(this.form.links.length > 0 && this.uploaded_torrent > 0) {

              //     this.$refs.myVueDropzone.processQueue();
              //     $('#process_nzb').html('<i class="fas fa-spinner fa-pulse"></i>').removeClass('btn-primary').addClass('btn-secondary').prop('disabled', true);

              //     var links = this.form.links.split('\n');
              //     var filtered_lines = links.filter(function (el) {
              //       return el != '' ;
              //     });

              //       $('#process_nzb').html('<i class="fas fa-spinner fa-pulse"></i>').removeClass('btn-primary').addClass('btn-secondary').prop('disabled', true);
      
              //     axios.post('/api/transfers/create',{link : filtered_lines, passwords: this.form.passwords , folder_id : this.folder_id}).then(response=>{

              //       $('#process_nzb').html('Add New NZB').removeClass('btn-secondary').addClass('btn-primary').prop('disabled', false);

              //       this.form.links = '';
                    
              //       if(response.data.status == 'success'){
              //         this.updateList();
              //         flash(response.data.message, response.data.alert);
              //       } 
                   
              //     }).catch(error=>{
              //         flash(JSON.parse(error.request.response).message, 'error');
              //         $('#process_nzb').html('Add New NZB').removeClass('btn-secondary').addClass('btn-primary').prop('disabled', false);
              //     });
              
              // } else {
              //   e.preventDefault();
              // }
              
            },
            uploadSuccess(file, response) {
              $('button#process_nzb').html('Add new transfer').removeClass('btn-secondary').addClass('btn-primary').prop('disabled', false);
              this.hideTransfer();
              $('.uploader_complete').addClass('d-none');
              $('.uploader_dropzone').removeClass('d-none');
              this.updateList();
              flash(response.message, response.alert);
            },
            uploadError(file, response) {
              $('button#process_nzb').html('Add new transfer').removeClass('btn-secondary').addClass('btn-primary').prop('disabled', false);
              this.uploaded_torrent = 0;
              this.uploaded_files = {};
              $('.uploader_complete').addClass('d-none');
              $('.uploader_dropzone').removeClass('d-none');   
              if(response == 'You can not upload any more files.'){
                flash('Too many files selected: add max. 10 nzb files.', 'error');    
              } else {
                flash(response.message, 'error');    
              }      
            },
            resetDropzone(){
              this.$refs.myVueDropzone.removeAllFiles();   
            },
            handleChange: function(key,el) {
              this.passwords[key] = el.target.value;
            },
            list(){

              axios.get('/api/transfers/list').then( response=> {
                    this.transfers_finished =response.data.transfers_list.finished;
                    this.transfers_running = response.data.transfers_list.running;
                    this.transfers_queued = response.data.transfers_list.queued;
                    this.transfers_error = response.data.transfers_list.error;
                    this.transfers_all = response.data.transfers_list.all;

                    var clear = true;
                    for(var i = 0; i < this.transfers_running.length; i++) {
                     
                      if(this.transfers_running[i].status == 'running') {

                          clear = false; 
                          break;
                      }
                    }

                    for(var i = 0; i < this.transfers_queued.length; i++) {
                      if(this.transfers_queued[i].status == 'queued') {
                          clear = false; 
                          break;
                      }
                    }
                    
                    if(clear) {
                        clearInterval(this.interval);
                    }

                }).catch(error=>{
                    flash(JSON.parse(error.request.response).message, 'error');
                })
            },
            // onEnterCreate: function (e){
            //   if (e.keyCode === 13 && !e.shiftKey && this.form.links.length > 0) {

            //       var links = this.form.links.split('\n');
            //       var filtered_lines = links.filter(function (el) {
            //         return el != '' ;
            //       });

            //     if(filtered_lines.length > 0){

            //       $('#process_nzb').html('<i class="fas fa-spinner fa-pulse"></i>').removeClass('btn-primary').addClass('btn-secondary').prop('disabled', true);                
            //           axios.post('/api/transfers/create',{link : filtered_lines , folder_id : this.folder_id}).then(response=>{

            //             $('#process_nzb').html('Add New NZB').removeClass('btn-secondary').addClass('btn-primary').prop('disabled', false);

            //             this.form.links = '';
                        
            //             if(response.data.status == 'success'){
                          
            //               this.updateList();
            //               flash(response.data.message, response.data.alert);
            //             } 
                       
            //           }).catch(error=>{
            //               flash(JSON.parse(error.request.response).message, 'error');

            //               $('#process_nzb').html('Add New NZB').removeClass('btn-secondary').addClass('btn-primary').prop('disabled', false);
            //           });
            //       }
            //   }
              
            // },
            // create: function (e) {

            //   $('button#add_new_torrent').prop('disabled', true);
            //   $('button#add_new_torrent').html('<i class="fas fa-spinner fa-pulse"></i>').removeClass('btn-primary').addClass('btn-secondary');

            //   var links = this.form.links.split('\n');
            //   var filtered_lines = links.filter(function (el) {
            //     return el != '' ;
            //   });
   
            //   //for(var i = 0; i < filtered_lines.length; i++) {

            //       axios.post('/api/transfers/create',{link : filtered_lines , folder_id : this.folder_id}).then(response=>{

            //         $('button#add_new_torrent').html('Add New NZB').removeClass('btn-secondary').addClass('btn-primary');
            //         $('button#add_new_torrent').prop('disabled', false);

            //         this.form.links = '';
                    
            //         if(response.data.status == 'success'){
            //           this.updateList();
            //           flash(response.data.message, response.data.alert);
            //         } 
                   
            //       }).catch(error=>{
            //           flash(JSON.parse(error.request.response).message, 'error');
            //           $('button#add_new_torrent').html('Add New NZB').removeClass('btn-secondary').addClass('btn-primary');
            //           $('button#add_new_torrent').prop('disabled', false);
            //       });
                
            //   //}
            // },
            // createMobile: function (e) {

            //   $('button#add_new_torrent_mobile').prop('disabled', true);
            //   $('button#add_new_torrent_mobile').html('<i class="fas fa-spinner fa-pulse"></i>').removeClass('btn-primary').addClass('btn-secondary');

            //   var links = this.form.links.split('\n');
            //   var filtered_lines = links.filter(function (el) {
            //     return el != '' ;
            //   });
   
            //   for(var i = 0; i < filtered_lines.length; i++) {



            //       axios.post('/api/transfers/create',{link : filtered_lines[i] , folder_id : this.folder_id}).then(response=>{

            //         $('button#add_new_torrent_mobile').html('Add New NZB').removeClass('btn-secondary').addClass('btn-primary');
            //         $('button#add_new_torrent_mobile').prop('disabled', false);

            //         this.form.links = '';
                    
            //         if(response.data.status == 'success'){
                      
            //           this.updateList();
            //           flash(response.data.message, 'success');
            //         } 
                   
            //       }).catch(error=>{
            //           flash(JSON.parse(error.request.response).message, 'error');
            //           //flash('Torrent failed to add.', 'error');
            //           $('button#add_new_torrent_mobile').html('Add New NZB').removeClass('btn-secondary').addClass('btn-primary');
            //           $('button#add_new_torrent_mobile').prop('disabled', false);
            //       });
                
            //   }
            // },
            deleteConfirm(item){
              this.delete_item = item;
              if(localStorage.confirm_delete && (localStorage.confirm_delete == 'false' || localStorage.confirm_delete == false)){
                this.deleteTransfer(item.id);
              } else {
                $('#deleteModal').modal('toggle');
              }
              
            },
            deleteTransfer() {
                if(this.form.ask == 'true' || this.form.ask == true){
                  localStorage.confirm_delete = false;
                }

                $('#deleteModal').modal('hide');
                $("button#delete_"+this.delete_item.id).attr("disabled", true);
                $('button#delete_'+this.delete_item.id).html('<i class="fas fa-spinner fa-pulse  text-secondary"></i>');
                
                axios.delete('api/transfers/delete/'+this.delete_item.id).then(response=>{
                  this.list();
                  $('button#delete_'+this.delete_item.id).html('<i class="fas fa-times-circle text-secondary"></i>').attr("disabled", false);
                }).catch(error=>{
                    flash('Error on deleting torrent', 'error');
                    $('button#delete_'+this.delete_item.id).html('<i class="fas fa-times-circle text-secondary"></i>').attr("disabled", false);
                });
            },
            zipTransfer(e,index,folder_id,file_id) {

                if(localStorage.always_start_download === undefined){
                  localStorage.always_start_download = false;
                }
              
                this.zip_data =  { link: null, finish: false, error: null };

                if(localStorage.always_start_download && (localStorage.always_start_download == 'false' || localStorage.always_start_download == false)){
                  $('#zipModal').modal('toggle');
                } 

                axios.post('api/zip/generate',{'folder_ids': [folder_id]}).then(response=>{
                    //$('button#zip_'+index).html('Download .zip').attr("disabled", false);;
                      if(response.data.status == 'success'){

                        if(localStorage.always_start_download && (localStorage.always_start_download == 'true' || localStorage.always_start_download == true)){
                          window.location.href = response.data.location;
                        } else {
                           this.zip_data = { link: response.data.location, finish: true, error: null };
                        }
                      }

                  }).catch(error=>{
                      //$('button#zip_'+index).html('Download .zip').attr("disabled", false);;
                       //flash(JSON.parse(error.request.response).message, 'error');
                       this.zip_data = { link: null, finish: true, error:  JSON.parse(error.request.response).message };
                });
            },
            clearFinished(e) {
                if(this.transfers_finished.length == 0){
                   flash('Transfers are empty.', 'error');
                } else {
                  $("button#clear_finished_btn").attr("disabled", true);
                  $("button#clear_finished_btn").html('<i class="fas fa-spinner fa-pulse  text-secondary"></i>');
                  axios.get('api/transfers/clearfinished').then(response=>{
                      $("button#clear_finished_btn").html('Clear Finished').attr("disabled", false);;
                      if(response.data.status == 'success'){
                        this.list();
                        //this.folderTree();
                        flash(response.data.message, 'success');
                      } else {
                         flash('Error on clearing finished transfers', 'error');
                      }
                  }).catch(error=>{
                      
                      $("button#clear_finished_btn").html('Clear Finished').attr("disabled", false);;
                      flash(JSON.parse(error.request.response).message, 'error');
                  });
                }
                
                
            },
            onPaste (e) {

                var clipboardData, pastedData;
                //e.stopPropagation();
                e.preventDefault();
                clipboardData = e.clipboardData || window.clipboardData;
                pastedData = clipboardData.getData('Text');
                var i = (pastedData.match(/\n/g) || []).length;
                if (i > 0) {
                    $(".torrent_link").addClass("d-none");
                    $(".torrent_links").removeClass("d-none");
                    $("#torrent_links").attr("rows", i + 1);
                    $("#torrent_links").val(pastedData+"\r");
                    $("#torrent_links").focus();
                    this.form.links = pastedData;
                    console.log(this.form.links);
                    // if($("#torrent_links").val() == ''){
                    //   $("#torrent_links").val(pastedData);
                    // }
                    //var height = $('.js__torrent-link-textarea').height();
                    //$(".selectFolderBtn").attr('style', 'height: ' + (height + 18) + 'px !important');
                } else {
                  $("#torrent_link").val(pastedData);
                  this.form.links = pastedData;
                  console.log(this.form.links);
                }

            },
            onEnter (e) {
              if (e.keyCode == 13 && e.shiftKey) {
                e.preventDefault();
                e.stopPropagation();
                //$(e.target).addClass("d-none");
                $(".torrent_link").addClass("d-none");
                $(".torrent_links").removeClass("d-none");
                $(".js__torrent-link-textarea").attr("rows", 2).focus().val(e.target.value + "\r");


                // $(".js__torrent-link-textarea").removeClass("d-none")
                // var height = $('.js__torrent-link-textarea').height();
                // $(".selectFolderBtn").attr('style', 'height: ' + (height + 18) + 'px !important');
                
              }
            },
            onFocusIn (e) {
              $(".nav-tabs .nav-link.active .tabs-navigation-arrow").addClass("focused");
            },
            onFocusOut (e) {
              $(".nav-tabs .nav-link.active .tabs-navigation-arrow").removeClass("focused");
            },
            showTransfer (e){
               this.mobile_transfer = true;
               $(e.target).addClass("d-none");
            },
            hideTransfer (e){
              this.mobile_transfer = false;
              this.$refs.myVueDropzone.removeAllFiles();
              this.uploaded_torrent = 0;
              this.uploaded_files = {};
              $("#addTorrentButton").removeClass("d-none");
              $("#nav-add-mobile").addClass("active show");
              $("#nav-upload-mobile-tab").removeClass("active");
              $("#nav-upload-mobile").removeClass("active show");

            },
            downloadURL(url){
              var iframe = document.createElement('iframe');
              iframe.style.display = 'none';
              document.body.appendChild(iframe);
              iframe.src = url;
            }
        }
    }
</script>